
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recycling",
      function () {
        return require("private-next-pages/recycling/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recycling"])
      });
    }
  